import { render, staticRenderFns } from "./LeftBox2.vue?vue&type=template&id=10fef4d2&scoped=true"
import script from "./LeftBox2.vue?vue&type=script&lang=js"
export * from "./LeftBox2.vue?vue&type=script&lang=js"
import style0 from "./LeftBox2.vue?vue&type=style&index=0&id=10fef4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fef4d2",
  null
  
)

export default component.exports